// Iter 27 — Live clock + date in WIB (Asia/Jakarta) timezone.
//
// Renders a small pill showing current time + date in Indonesian locale.
// Updates every second. Used in dashboard header next to "Welcome back".

import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const TZ = "Asia/Jakarta";

function formatWIBTime(d) {
  return new Intl.DateTimeFormat("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: TZ,
  }).format(d);
}

function formatWIBDate(d) {
  return new Intl.DateTimeFormat("id-ID", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: TZ,
  }).format(d);
}

export default function WIBClock({ className = "" }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 border font-mono text-[11px] sm:text-xs ${className}`}
      style={{borderColor: "var(--app-border)", color: "var(--app-muted)"}}
      data-testid="wib-clock"
      title="Waktu Indonesia Barat (WIB)"
    >
      <Clock size={11} strokeWidth={1.5} />
      <span data-testid="wib-clock-time">{formatWIBTime(now)}</span>
      <span aria-hidden>·</span>
      <span className="hidden sm:inline" data-testid="wib-clock-date">{formatWIBDate(now)}</span>
      <span className="sm:hidden">{formatWIBDate(now).split(" ").slice(0, 3).join(" ")}</span>
      <span className="opacity-60 ml-0.5">WIB</span>
    </div>
  );
}
